<template>
    <div class="slider-blog">
        <swiper :options="swiperOption" @someSwiperEvent="callback" dir="rtl" ref="mySwiper">
            <swiper-slide v-for="(item,index) in blogs" :key="index">
                <list-blog :user-id="item.user_id" :img="item.img" :title="item.title" :fullname="item.fullname" :pub_date="item.pub_date" :id="item.id" />
            </swiper-slide>
        </swiper>
        <div class="contoroller">
            <div class="next flaticon-left-arrow" @click="goNext"></div>
            <div class="prev flaticon-right-arrow" @click="goPerv"></div>
        </div>
    </div>
</template>

<script>
import listBlog from 'cp/blog/list.vue'

export default {
    name: 'list-courses',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    components: {
        listBlog
    },
    computed: {
        windowWidth () {
            return this.$store.state.layout.windowWidth
        },
        isMobile () {
            return this.windowWidth < 992
        },
        swiper () {
            return this.$refs.mySwiper.swiper
        },
        blogs () {
            return this.$store.state.blog.listBlog || null
        }
    },

    data () {
        return {
            showPopperParentVar: false,
            starVal: 3.3,
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 15,
                loop: true,
                // autoplay: {
                //   delay: 2500,
                //   disableOnInteraction: false
                // },
                // pagination: {
                //   el: '.swiper-pagination',
                //   clickable: true
                // }
                breakpoints: {
                    1200: { slidesPerView: 3 },
                    968: { slidesPerView: 3 },
                    768: { slidesPerView: 2 },
                    593: { slidesPerView: 1 },
                }

            }
        }
    },

    methods: {
        getBlog (p) {
            this.$store.dispatch('blog/getListBlog', { page_num: p })
        },
        removeFavorit (e) {
            // console.log(e)
        },
        callback () {
            // console.log('hell')
        },
        goNext () {
            this.swiper.slideNext()
        },
        goPerv () {
            this.swiper.slidePrev()
        }
    },
    mounted () {
        this.getBlog(1)
    },
}
</script>
<style lang="less" scoped>
.slider-blog {
  .swiper-scrollbar {
    background: transparent;
  }
  .contoroller {
    width: 100%;
    position: absolute;
    right: 0;
    left: 0;
    top: 50%;
  }
  .prev,
  .next {
    background-color: #fff;
    background-image: none;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    // width: 27px;
    // height: 44px;
    margin-top: -22px;
    border-width: 0;
    box-shadow: 0 0 1px 1px rgba(20, 23, 28, 0.1),
      0 3px 1px 0 rgba(20, 23, 28, 0.1);
    color: #007791;
    font-size: 24px;
    height: 47px;
    line-height: 1;
    padding: 12px 0;
    text-align: center;
    transition: 0.3s;
    width: 47px;
    z-index: 3;
    cursor: pointer;
    // display: none;
    &:hover {
      box-shadow: 0 2px 8px 2px rgba(20, 23, 28, 0.15);
      color: #00576b;
    }
  }
  .prev {
    right: -50px;
  }
  .next {
    left: -50px;
  }
}
@media screen and (max-width: 992px) {
  .slider-blog .contoroller {
    top: 100%;
  }
  .prev {
    right: 40% !important;
    top: 102% !important;
  }
  .next {
    left: 40% !important;
    top: 102% !important;
  }
}
@media screen and (max-width: 593px) {
  .prev {
    right: 30% !important;
  }
  .next {
    left: 30% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog/slider.vue